/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Issues_MoreInputs */

const en_issues_more = /** @type {(inputs: Issues_MoreInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`…and ${i?.count} more`)
};

/**
* | output |
* | --- |
* | "…and {count} more" |
*
* @param {Issues_MoreInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issues_more = /** @type {((inputs: Issues_MoreInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issues_MoreInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issues_more(inputs)
});